import { render } from "./Cannibalization.vue?vue&type=template&id=8e5b12e0&scoped=true"
import script from "./Cannibalization.vue?vue&type=script&lang=js"
export * from "./Cannibalization.vue?vue&type=script&lang=js"

import "./Cannibalization.vue?vue&type=style&index=0&id=8e5b12e0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e5b12e0"]])

export default __exports__